<button
	*ngIf="!asLabel"
	tlkButton
	size="m"
	variant="secondary"
	[attr.data-testid]="'indication-' + indicationClass"
	[class]="['rx-intuitive-indication-button', indicationClass]"
	[class.rx-intuitive-indication-button--active]="isActive"
	[disabled]="disabled"
	(click)="onClicked()"
>
	<span *ngIf="!hideIcon" class="rx-intuitive-indication-button__icon"></span>
	<span class="rx-intuitive-indication-button__label">{{ indication | indicationTranslate }}</span>
</button>
<div
	*ngIf="asLabel"
	[class]="['rx-intuitive-indication-button', 'rx-intuitive-indication-button--label', indicationClass]"
	[class.rx-intuitive-indication-button--active]="isActive"
	role="status"
>
	<span class="rx-intuitive-indication-button__icon"></span>
	<span class="rx-intuitive-indication-button__label">{{ indication | indicationTranslate }}</span>
</div>
